<template>
  <v-col v-if="!!budgetLength" cols="12">
    <v-row>
      <v-col cols="12" class="pb0">
        <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
          Presupuestos
        </h6>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="pb0 visit"
        v-for="item in budgetList"
        :key="item.id"
      >
        <div
          @click="showBudgetDetail(item)"
          style="
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px;
            border-radius: 5px;
          "
          :class="{
            highlighted: item.status_budget.id == 2,
            regular: item.status_budget.id != 2,
          }"
        >
          <div style="display: flex; align-items: center">
            <v-icon
              v-if="item.status_budget.id == 1"
              color="#1565c0"
              :class="{ dim: fab }"
            >
              note_add
            </v-icon>

            <v-icon
              color="success"
              v-if="item.status_budget.id == 2"
              :class="{ dim: fab }"
            >
              check_circle
            </v-icon>

            <v-icon
              color="success"
              v-if="item.status_budget.id == 3"
              :class="{ dim: fab }"
            >
              check_circle
            </v-icon>

            <v-icon
              color="error"
              v-if="item.status_budget.id == 4"
              :class="{ dim: fab }"
            >
              remove_circle
            </v-icon>

            <v-icon
              color="#ff8f00"
              v-if="item.status_budget.id == 5"
              :class="{ dim: fab }"
            >
              help
            </v-icon>

            <v-icon
              v-if="item.status_budget.id == 6"
              color="#ff8f00"
              :class="{ dim: fab }"
            >
              find_in_page
            </v-icon>

            <v-icon
              color="error"
              v-if="item.status_budget.id == 7"
              :class="{ dim: fab }"
            >
              error
            </v-icon>

            <div class="ml-2">
              <p style="margin-bottom: 0px; font-size: 13px; font-weight: bold">
                {{ item.status_budget.name }}
              </p>
              <p style="margin-bottom: 0; text-transform: capitalize">
                {{ formatDate(item.created_at) }}
              </p>
              <p style="margin-bottom: 0">{{ totalAmount(item) }}</p>
            </div>
          </div>

          <v-icon color="#9e9e9e" :class="{ dim: fab }">
            keyboard_arrow_right
          </v-icon>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="budgetLength > 2">
      <v-col cols="12" class="pb0 showAll">
        <v-btn
          text
          style="
            color: #1565c0;
            cursor: pointer;
            font-weight: 400;
            margin-top: 20px;
          "
          @click="showAll()"
        >
          Ver todos los presupuestos ({{ budgetLength }})
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  props: {
    requestId: Number,
  },
  mounted() {
    this.getBudgetList();
  },
  data: () => ({
    budgetList: [],
    budgetLength: 0,
    fab: false,
  }),
  methods: {
    showAll() {
      console.log("HI");
      this.$router.push({
        name: "budget-list",
        query: { requestId: this.requestId },
      });
    },
    showBudgetDetail(budget) {
      if (budget) {
        this.$store.commit("set_current_budget", budget);
      } else {
        this.$store.commit("set_current_budget", {});
      }

      this.$router.push({ name: "budget-detail" });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
    totalAmount: function (item) {
      if (item.supplies_budget && item.manpower_budget) {
        return (
          "$" + (Number(item.supplies_budget) + Number(item.manpower_budget))
        );
      }
      if (item.supplies_budget) {
        return "$" + Number(item.supplies_budget);
      }
      if (item.manpower_budget) {
        return "$" + Number(item.manpower_budget);
      }
      return "$ -";
    },
    getBudgetList() {
      this.axios
        .get(`/budget/?request_id=${this.requestId}`)
        .then((response) => {
          this.budgetLength = response.data.results.length;
          if (this.budgetLength <= 2) {
            this.budgetList = response.data.results;
          } else {
            this.budgetList = this.filterBudgetList(response.data.results);
          }
        })
        .catch(() => {});
    },
    filterBudgetList(budgetList) {
      let pending = budgetList.filter((item) => item.status_budget.id == 5);
      let approved = budgetList.filter((item) => item.status_budget.id === 2);
      let rest = budgetList.filter(
        (item) => item.status_budget.id !== 2 && item.status_budget.id !== 5
      );

      if (pending.length >= 2) {
        return pending.slice(0, 2);
      }

      if (pending.length) {
        if (approved.length) return [pending[0], approved[0]];
        return [pending[0], rest[0]];
      }

      if (approved.length >= 2) {
        return approved.slice(0, 2);
      }

      if (approved.length) {
        return [approved[0], rest[0]];
      }

      return rest.slice(0, 2);
    },
  },
};
</script>
<style scoped>
@media (max-width: 959px) {
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
  .dim {
    opacity: 0.3;
  }
  .visit {
    border-bottom: 1px solid lightgrey;
    padding: 0px;
  }
  .showAll {
    display: flex;
    justify-content: center;
  }
}
@media (min-width: 960px) {
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
  .regular {
    background: #eeeeee;
  }
  .regular:hover {
    background: #fafafa;
  }
  .visit {
    padding: 12px;
  }
  .fix-desk {
    transform: translateX(260px);
  }
  .showAll {
    display: flex;
    justify-content: flex-start;
  }
}
.highlighted {
  background: #e1f5fe;
}
.highlighted:hover {
  background: #ecf9ff;
}

.menu-container {
  display: flex;
  justify-content: flex-end;
}
.bodypad {
  padding: 12px 24px 108px 24px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.in-bl {
  display: inline-block;
}
.icon-cont {
  display: flex;
  justify-content: flex-end;
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
}
.fab-but-cont {
  display: flex;
  justify-content: flex-start;
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.urgent {
  background-color: rgba(255, 251, 203, 0.5) !important;
}
</style>
